import { IS_PROD } from './environment';
export var FIGURE_ORIGIN = "https://".concat(IS_PROD ? 'www' : 'test', ".figure.com");